var map = {
	"./google-laurel-da-DK.svg": 6047,
	"./google-laurel-de-DE.svg": 37661,
	"./google-laurel-en-GB.svg": 40911,
	"./google-laurel-en-US.svg": 55448,
	"./google-laurel-es-ES.svg": 28639,
	"./google-laurel-es-MX.svg": 46156,
	"./google-laurel-fr-FR.svg": 77779,
	"./google-laurel-it-IT.svg": 89669,
	"./google-laurel-nb-NO.svg": 11902,
	"./google-laurel-nl-NL.svg": 81739,
	"./google-laurel-pl-PL.svg": 26607,
	"./google-laurel-pt-BR.svg": 66127,
	"./google-laurel-pt-PT.svg": 66559,
	"./google-laurel-sv-SE.svg": 50574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;